function mobileFooterToggle() {
  const accHead = document.querySelectorAll('.js-acc-head');

  accHead.forEach(function(item){
    item.addEventListener('click',function(){
      const contentElement = item.nextElementSibling;
      console.log(contentElement.scrollHeight);

      if(this.classList.contains('open')){
        this.classList.remove('open');
        this.nextElementSibling.style.height = 0;
        this.nextElementSibling.setAttribute('aria-hidden', 'true');
        this.parentElement.setAttribute('aria-haspopup', 'true');
      } else {

        // accHead.forEach(function(item){
        //   item.classList.remove('open');
        //   item.nextElementSibling.style.height = contentElement.scrollHeight + 'px';
        //   item.nextElementSibling.setAttribute('aria-hidden', 'true');
        //   item.parentElement.setAttribute('aria-haspopup', 'true');
        // });

        //if(i()){} メディアクエリ768px以下でのみ本来は実行

        this.classList.add('open');
        this.nextElementSibling.style.height = contentElement.scrollHeight + 'px';
        this.nextElementSibling.removeAttribute('aria-hidden');
        this.parentElement.removeAttribute('aria-haspopup');
        this.dispatchEvent(new Event('opened'));

      }
    });
  });

}

/* 移植元コード（移植中）
function r(e, t, n) {
  var r = $(t).closest(".text-holder")
    , o = $(t).closest(".grid-wrap");
  
  $(t).hasClass("open") ? 
  ($(t).removeClass("open").next().stop().slideUp().attr("aria-hidden", "true"),
  $(t).parent().attr("aria-haspopup", "true")) : (i() && (e.removeClass("open").next().stop().slideUp().attr("aria-hidden", "true"),
  e.parent().attr("aria-haspopup", "true")),
  $(t).addClass("open").next().stop().slideDown("slow", function() {
      r.hasClass("js-equal-height") && o.animate({
          height: o.height() + $(t).siblings()[0].offsetHeight
      })
  }).removeAttr("aria-hidden"),
  $(t).parent().removeAttr("aria-haspopup"),
  $(t).triggerHandler("opened"),
  n || c.pushPDPTabsEvent($(t), u))
}

function r(e, t, n) {
  var r = $(t).closest(".text-holder"),
      o = $(t).closest(".grid-wrap");
  
  if ($(t).hasClass("open")) {
    $(t).removeClass("open").next().stop().slideUp().attr("aria-hidden", "true");
    $(t).parent().attr("aria-haspopup", "true");
  } else {
    if (i()) //メディアクエリ {
      e.removeClass("open").next().stop().slideUp().attr("aria-hidden", "true");
      e.parent().attr("aria-haspopup", "true");
    }

    $(t).addClass("open").next().stop().slideDown("slow").removeAttr("aria-hidden");

    $(t).parent().removeAttr("aria-haspopup");
    $(t).triggerHandler("opened");

  }
}
*/


/*=== 実行 ============================================*/
// DOM読み込み完了時に実行
window.addEventListener('DOMContentLoaded',function(){
  mobileFooterToggle();
});